import type { PasskeyListResponse } from "./api/passkeys.api";

function readVerdict(list: PasskeyListResponse, key: string): boolean | undefined {
  const value = (list as unknown as Record<string, unknown>)[key];
  return typeof value === "boolean" ? value : undefined;
}

export function passkeyEnrolmentReplacesCodes(
  list: PasskeyListResponse | undefined,
  mfaEnabled: boolean,
): boolean {
  if (list !== undefined) {
    const verdict = readVerdict(list, "passkeyEnrollmentReplacesRecoveryCodes");
    if (verdict !== undefined) return verdict;
    return list.passkeys.length === 0;
  }
  return !mfaEnabled;
}

export function totpConfirmationReplacesCodes(
  list: PasskeyListResponse | undefined,
  mfaEnabled: boolean,
): boolean {
  if (list !== undefined) {
    const verdict = readVerdict(list, "totpConfirmationReplacesRecoveryCodes");
    if (verdict !== undefined) return verdict;
  }
  return !mfaEnabled;
}
